import * as React from 'react';
import { Dropdown, Flag, Icon, Menu } from 'semantic-ui-react';
import { useAccessToken } from '~/AccessToken';
import { DashboardRoute, NotificationsFeedRoute, ReportsRoute, UserProfileRoute } from '~/Application/routes';
import * as googleTagManager from '~/GoogleTagManager';
export var MenuItem;
(function (MenuItem) {
    MenuItem[MenuItem["dashboard"] = 0] = "dashboard";
    MenuItem[MenuItem["reports"] = 1] = "reports";
    MenuItem[MenuItem["notifications"] = 2] = "notifications";
})(MenuItem || (MenuItem = {}));
var LocaleNotificationNavigation = function () {
    var message = 'Děkujeme za zájem, funkci aktuálně vyvíjíme a pomohli jste její prioritizaci.';
    var log = function () {
        googleTagManager.push({ event: 'mit.notImplementedFeature', notImplementedFeature: 'Locale + Notification Panel' });
        // eslint-disable-next-line no-alert
        alert(message);
    };
    return (<Menu.Item title={message} onClick={log}>
			<Icon name='chat' size='large' style={{ marginRight: '10px' }}/>
			<Flag name='uk' size='large' style={{ marginRight: '0px' }}/>
		</Menu.Item>);
};
var UserNavigation = function (_a) {
    var activeMenuItem = _a.activeMenuItem, user = _a.user, onLogout = _a.onLogout;
    return (<>
		<Menu.Item active={activeMenuItem === MenuItem.dashboard} as={React.useCallback(function (props) { return (<DashboardRoute.Link>
						<a {...props}/>
					</DashboardRoute.Link>); }, [DashboardRoute.Link, activeMenuItem])}>
			Aktuality
		</Menu.Item>

		<Menu.Item active={activeMenuItem === MenuItem.reports} as={React.useCallback(function (props) { return (<ReportsRoute.Link>
						<a {...props}/>
					</ReportsRoute.Link>); }, [ReportsRoute.Link, activeMenuItem])}>
			Reporty
		</Menu.Item>

		<Menu.Menu position='right'>
			<Menu.Item active={activeMenuItem === MenuItem.notifications} as={React.useCallback(function (props) { return (<NotificationsFeedRoute.Link>
							<a {...props}/>
						</NotificationsFeedRoute.Link>); }, [NotificationsFeedRoute.Link, activeMenuItem])}>
				<span style={{ position: 'relative', marginRight: '1em' }}>
					<Icon name='bell' size='large'/>
				</span>
			</Menu.Item>
			<LocaleNotificationNavigation />

			<Dropdown item as={React.useCallback(function (props) { return (<Menu.Item {...props} as='div'/>); }, [])} data-testid='right-menu' text={user.name}>
				<Dropdown.Menu>
					<Dropdown.Item>Uživatelský profil</Dropdown.Item>
					<Dropdown.Item as={React.useCallback(function (props) { return (<UserProfileRoute.Link>
									<a {...props}/>
								</UserProfileRoute.Link>); }, [UserProfileRoute.Link])}>
						Nastavení
					</Dropdown.Item>
					<Dropdown.Item onClick={onLogout}>Odhlásit se</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		</Menu.Menu>
	</>);
};
UserNavigation.displayName = 'Application.UserNavigation';
export var Navigation = function (_a) {
    var _b, _c;
    var _d = _a.activeMenuItem, activeMenuItem = _d === void 0 ? null : _d;
    var _e = useAccessToken(), accessToken = _e[0], setAccessToken = _e[2];
    var user = (_c = (_b = accessToken.value) === null || _b === void 0 ? void 0 : _b.user) !== null && _c !== void 0 ? _c : null;
    return (<Menu as='header'>
			<Menu.Item header as={React.useCallback(function (props) { return (<DashboardRoute.Link>
							<a {...props}/>
						</DashboardRoute.Link>); }, [DashboardRoute.Link])}>
				MIT by COGVIO
			</Menu.Item>

			{user !== null ? (<UserNavigation activeMenuItem={activeMenuItem} user={user} onLogout={function () {
                setAccessToken(null);
            }}/>) : null}
		</Menu>);
};
Navigation.displayName = 'Application.Navigation';
